export const AuthEndpoints = Object.freeze({
  Authentication: '/v3/auth',
  OtpVerify: '/v3/auth/verify',
  Login: '/v3/auth/signin',
  Logout: '/v3/auth/signout',
  External: '/v3/auth/external',
  Register: {
    CheckUsername: '/v3/user/username',
    CheckPassword: '/v3/user/password'
  },
  ForgetPassword: {
    SendCode: '/v3/auth/forgetPassword/sendCode',
    CheckCode: '/v3/auth/forgetPassword/checkCode',
    ChangePassword: '/v3/auth/forgetPassword/changePassword'
  },
  signup: {
    SendCode: '/v3/auth/signup/code/send',
    CheckCode: '/v3/auth/signup/code/verify'
  },
  EmailSend: '/v3/auth/email/send',
  EmailVerify: '/v3/auth/email/verify',
  MobileSend: '/v3/auth/mobile/send',
  MobileVerify: '/v3/auth/mobile/verify',
  CaptchaCheck: (route: string) => `/v3/auth/captcha/check?route=${route}`
})

// send
// verify -> store token
// patch username -> stored token sent through headers
// patch password -> stored token sent through headers
